import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type RiskModelPreviewAssetPertinenceProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'risk_model_pertinence_preview', string>;
  goFullScreen?: (_b: string) => void;
  fullScreen?: boolean;
  context?: ts.types.universe.UniversePreviewContext;
  queryParams?: { initial?: string };
};

const RiskModelPreviewAssetPertinence = ({
  id,
  loadWidgetData,
  widgetPaths,
  mode,
  context,
  params,
  setParams,
  fullScreen,
  goFullScreen,
  queryParams,
}: RiskModelPreviewAssetPertinenceProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        loadWidgetData={loadWidgetData}
        assetPertinence={widgetPaths['risk_model_pertinence_preview']}
        fullScreen={fullScreen}
        context={context}
        queryParams={queryParams}
        goFullScreen={goFullScreen}
        params={params as Params}
        setParams={setParams}
      />
    </>
  );

  return (
    <>
      {mode == ts.enums.CHART_MODE_ENUM.EDIT ? (
        <Form
          params={params}
          setParams={setParams}
          riskModelStartDate={context?.start_date}
          riskModelEndDate={context?.end_date}
        />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default RiskModelPreviewAssetPertinence;
